import { useHomepagePromotions } from "@/Apollo/hooks/promotions/useHomepagePromotions";
import { PROMOTIONS_ENABLED } from "@/features/promotions/config";
import { usePromotionCopy } from "@/features/promotions/hooks/usePromotionCopy";
import { ProductCard } from "@/features/search/components/product-card/ProductCard";
import { toCardProduct } from "@/features/search/utils/gateway-product.utils";
import { Heading } from "@/ui/cva/Heading";

export const HomepagePromotions = () => {
  const query = useHomepagePromotions();
  const { copy } = usePromotionCopy();
  const cards = query.data?.homepagePromotions ?? [];

  if (!PROMOTIONS_ENABLED || query.loading || query.error || !cards.length) {
    return null;
  }

  return (
    <section
      className="flex flex-col gap-6"
      aria-label={`${copy("homepageHeading")} · ${copy("sponsored")}`}
    >
      <div className="text-center">
        <Heading as="h2" size="h3">
          {copy("homepageHeading")}
        </Heading>
        <p className="mb-0 mt-2 text-xs text-grey-700">{copy("sponsored")}</p>
      </div>
      <div className="flex w-full snap-x snap-mandatory scroll-px-4 gap-8 overflow-x-auto px-4 py-5 md:grid md:grid-cols-4 md:overflow-visible">
        {cards.slice(0, 4).map(({ product, promotion }) => (
          <div
            key={product.id}
            className="w-[60%] shrink-0 snap-start md:w-auto"
          >
            <ProductCard
              product={{
                ...toCardProduct(product),
                promotion: { ...promotion, token: promotion.token ?? null },
              }}
              compact
              /* The paid homepage row is the one place a card says "Sponsored". */
              showDisclosure
            />
          </div>
        ))}
      </div>
    </section>
  );
};
